import { AxiosResponse } from 'axios';

export const formatTokenRequestDate = (value?: string | null): string => {
    if (!value) {
        return '—';
    }

    const [datePart, timePart = ''] = value.split('T');
    const [year, month, day] = datePart.split('-');

    if (!year || !month || !day) {
        return value;
    }

    const time = timePart.slice(0, 5);

    return `${day}.${month}.${year}${time ? ` ${time}` : ''}`;
};

export const getRequestErrorMessage = (error: any): string => {
    const message = error?.response?.data?.message;

    const messages: Record<string, string> = {
        'error.api-token-request.not-found': 'Заявка не найдена',
        'error.api-token-request.attachment-not-found': 'Вложение не найдено',
        'error.api-token-request.already-issued':
            'По заявке уже выдан токен. Изменение статуса запрещено',
        'error.api-token-request.issue-via-status-forbidden':
            'Статус «Токен выдан» устанавливается только через выдачу токена',
        'error.api-token-request.not-approved':
            'Токен можно выдать только по согласованной заявке',
        'error.api-token-request.token-already-issued':
            'По заявке уже был выдан токен',
    };

    return messages[message] || message || 'Не удалось выполнить операцию';
};

const decodeFileName = (value: string): string => {
    try {
        return decodeURIComponent(value);
    } catch (_error) {
        return value;
    }
};

export const getResponseFileName = (
    response: AxiosResponse<Blob>,
    fallback: string
): string => {
    const disposition = response.headers?.['content-disposition'] || '';
    const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);

    if (utf8Match?.[1]) {
        return decodeFileName(utf8Match[1].replace(/["']/g, ''));
    }

    const regularMatch = disposition.match(/filename="?([^";]+)"?/i);

    return regularMatch?.[1] || fallback;
};

export const saveBlob = (blob: Blob, fileName: string): void => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
};